import { render, staticRenderFns } from "./BasicInformationHeader.vue?vue&type=template&id=220f76ed&scoped=true&"
import script from "./BasicInformationHeader.vue?vue&type=script&lang=js&"
export * from "./BasicInformationHeader.vue?vue&type=script&lang=js&"
import style0 from "./BasicInformationHeader.vue?vue&type=style&index=0&id=220f76ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220f76ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardTitle})
